let css = require('./top-header.css');
let signals = require('../../../../../signals/account/statistic');
let { cut } = require('../../../../../helpers/utils');

class LeftHeader {
    constructor () {
        this.template = require('./template.hbs');
        this.isListenersInit = false;
    }

    render () {
        return this.$context.getWatcherData().then((data) => Object.assign({}, data, { css }));
    }

    bind () {
        return {
            click: {
                [cut(css.expandable)]: this.expandItem
            }
        };
    }

    expandItem (e) {
        let id = e.target.attributes['cat-id'].value;
        this.$context.signal(signals.toggleItem(['account', 'statistic', 'xExtended'], id));
    }
}

module.exports = {
    constructor: LeftHeader
};



// WEBPACK FOOTER //
// ./components/account/statistic/scrollable/top-header/index.js